import t from "clipper-lib";
import { pathToPoly as a } from "./internal/index.js";
import { polyToPath as s } from "./internal/index2.js";
const r = 1e5;
function m(o) {
  const e = new t.Clipper(), i = o[0][0][1], c = s(o[0]), n = o.slice(1).map((p) => s(p));
  t.JS.ScaleUpPath(c, r), t.JS.ScaleUpPaths(n, r), e.AddPath(c, t.PolyType.ptSubject, !0), e.AddPaths(n, t.PolyType.ptClip, !0);
  const l = [];
  return e.Execute(t.ClipType.ctUnion, l, t.PolyFillType.pftNonZero, t.PolyFillType.pftNonZero), t.JS.ScaleDownPaths(l, r), l.map((p) => a(p, i));
}
export {
  m as unionPolygons
};
//# sourceMappingURL=index6.js.map
